import { doDelete, doGet, doPost, doPut } from "../../../api/baseAPI";
import { GROLOG_BASE_URL, GROLOG_URL } from "../../../constant/apiConstant";
import { setTableLoading } from '../../../store/reducer/page.reducer'
import { checkValidationToken } from "../../../util/errorHandler";

export const initiateDeliveryType = async (token, refresh_token, depot_id,keyword, dispatch) => {
    const url = `${GROLOG_URL}/delivery-type/initiate${keyword? `?filter=delivery_type lk `+keyword:""}`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const getListDeliveryType = async (token, refresh_token, param, depot_id, dispatch) => {
    const url = `${GROLOG_URL}/delivery-type?${param}`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const getListDeliveryTypeDropdown = async (token, page, keyword, refresh_token, dispatch) => {
    const params = {
        page: page,
        limit: 10,
        order: 'id asc',
        filter: keyword !== '' ? `depot_name lk ${keyword}` : ''
    }
    const url = `${GROLOG_URL}/depot-configuration/dropdown`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, params);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const getDetailDeliveryType = async (token, refresh_token, id, dispatch) =>{
    const url = `${GROLOG_URL}/delivery-type/${id}`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const postDeliveryType = async (token, refresh_token, data, dispatch) => {
    const url = `${GROLOG_URL}/delivery-type`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doPost(url, token, data)
        if (response) {
            result.code = response.status
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
        if(error.response.status === 400){
            result.code = error.response.status
            result.message = error.response?.data?.payload?.code
        }
    }
    return result
}

export const deleteDeliveryType = async (token, refresh_token, id, updated_at, dispatch) => {
    const url = `${GROLOG_URL}/delivery-type/${id}`
    let result = { data: undefined, ok: false }

    let data = {
        'updated_at': updated_at
    }

    try {
        const response = await doDelete(url, token, data)
        if (response) {
            result.ok = true
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const editDeliveryType = async (token, refresh_token, id, data, dispatch) => {
    const url = `${GROLOG_URL}/delivery-type/${id}`
    let result = { data: undefined, ok: false, code: undefined, message:undefined}

    try {
        const response = await doPut(url, token, data)
        if (response) {
            result.code = response.status
            result.ok = true
            result.data = response?.data?.payload?.data
        } 
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
        if(error.response.status === 400){
            result.code = error.response.status
            result.message = error.response?.data?.payload?.code
        }
    }
    return result
}


export const getSearchRecommendation = async (token, refresh_token, depot_id, keyword, dispatch) => {
    const url = `${GROLOG_URL}/delivery-type/search?page=1&limit=10&filter=delivery_type lk ${keyword}`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const getSearchResult = async (token, refresh_token, keyword, dispatch) => {
    const url = `${GROLOG_URL}/delivery-type?page=1&limit=10&filter=delivery_type lk ${keyword}`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const getManagementHistoryList = async (token, refresh_token, dispatch, id) => {
    const url = `${GROLOG_BASE_URL}/audit/v1/grolog/audit?page=1&filter=table_name eq delivery_type, primary_key eq ${id}`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}